<template>
  <div class="not-found-container">
    <div class="heading-text">
      {{ __('not_found_title') }}
    </div>
    <p class="body-text-bold">{{ __('not_found_subtitle') }}</p>
  </div>
</template>

<script lang="ts" setup>
import __ from '@/translate';
</script>
